import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useTranslation } from 'react-i18next'
import { toggleAllInclusive, toggleLastMinute } from '../../actions/formActions'
import { FORM_FILTERS } from '../../consts/data'
import './style.scss'

const SearchFilter = ({
    allInclusive,
    lastMinute,
    toggleAllInclusive,
    toggleLastMinute
}) => {
    const { t } = useTranslation()
    const filters = [];

    if (allInclusive) filters.push('all_inclusive');
    if (lastMinute) filters.push('last_minute');

    const handleClick = (filter) => {
        if (filter === 'all_inclusive') {
            toggleAllInclusive();
        } else if (filter === 'last_minute') {
            toggleLastMinute();
        }
    };

    return (
        <>
            <input type="hidden" name="filters" value={filters.join(',')} />
            <ul className="trip-form-filters">
                {Array.from(FORM_FILTERS).map((filter, key) => {
                    return (
                        <li
                            key={`filter-${key}`}
                            className={`trip-form-filter ${filters.includes(filter) ? 'trip-form-filter--active' : ''}`}
                            onClick={() => handleClick(filter)}
                        >
                            <span></span>
                            {t(`form.filters.${filter}`)}
                        </li>
                    )
                })}
            </ul>
        </>
    )
}

const mapStateToProps = (state) => ({
    allInclusive: state.formReducer.allInclusive,
    lastMinute: state.formReducer.lastMinute
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            toggleAllInclusive,
            toggleLastMinute
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(SearchFilter);
